import type { DocBlock } from "@alm/domain/legal";
import { LegalSpans, type LegalLink } from "@/components/marketing/site/legal/legal-spans";

type Table = Extract<DocBlock, { k: "table" }>;

/** One of Appendix A's tables. It scrolls sideways on a phone rather than squeezing, and takes
 * focus so the keyboard can scroll it too. */
export function LegalTable({ table, link }: { table: Table; link: LegalLink }) {
  return (
    <div
      role="region"
      aria-label={`${table.header[0]?.map((span) => span.text).join("") ?? "Table"}, table`}
      // oxlint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- a scroll region the keyboard must reach
      tabIndex={0}
      className="overflow-x-auto rounded-lg border border-border outline-hidden focus-visible:ring-[3px] focus-visible:ring-ring/80"
    >
      <table className="w-full min-w-[32rem] border-collapse text-left text-sm">
        <thead className="bg-card">
          <tr>
            {table.header.map((cell, index) => (
              <th
                // oxlint-disable-next-line react/no-array-index-key -- legal text rendered once from static data, never reordered
                key={`head-${index}`}
                scope="col"
                className="border-b border-border px-3 py-2 align-bottom font-semibold"
              >
                <LegalSpans spans={cell} link={link} linkBaa={false} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            // oxlint-disable-next-line react/no-array-index-key -- legal text rendered once from static data, never reordered
            <tr key={`row-${rowIndex}`} className="border-b border-border last:border-b-0">
              {row.map((cell, index) => (
                // oxlint-disable-next-line react/no-array-index-key -- legal text rendered once from static data, never reordered
                <td key={`cell-${index}`} className="px-3 py-2 align-top">
                  <LegalSpans spans={cell} link={link} linkBaa={false} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
